import styled from "styled-components";

export const PaymentWayWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 178px;
  padding: 24px;
  border-radius: 8px;
  background: rgba(41, 43, 47, 1);
  margin-top: 20px;
  .picture-vip-protocols {
    font-size: 12px;
    position: relative;
    color: #cbcccc;
    line-height: 22px;
    > span:last-child {
      position: absolute;
      width: max-content;
      bottom: 0;
      left: 16px;
    }
    .ant-checkbox-wrapper {
      width: 14px;
      height: 14px;
    }
    .ant-checkbox-inner {
      border: 1px solid #646c77;
    }
    a {
      color: var(--main-color);
    }
  }
`;

export const QRCodeContainer = styled.div`
  margin-right: 30px;
  width: 130px;
  height: 130px;
  border-radius: 6px;
  overflow: hidden;
  background: #2c2c31;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const QRCodeLoading = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  opacity: 0.6;
  border-radius: 6px;
`;

export const QRCodeDisabledProtocol = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(65, 65, 65, 0.87);
  border-radius: 6px;
  font-size: 12px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
`;

export const HiddenTopLeft = styled.div`
  position: absolute;
  top: 7px;
  left: 7px;
  width: 20px;
  height: 20px;
  background: #fff;
`;
export const RefreshButton = styled.div`
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 24px;
  }
  span {
    color: #d4d4d4;
    font-size: 12px;
  }
`;
export const PaymentContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;
export const Price = styled.div`
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.85);
  line-height: 36px;
  align-items: baseline;
  span:nth-child(3) {
    font-size: 26px;
    color: var(--main-color);
    font-weight: 500;
    margin: 0 2px;
  }
  .unit {
    color: var(--main-color);
    font-size: 16px;
    margin-left: 6px;
  }
`;

export const Gift = styled.div`
  background: #3d4045;
  border-radius: 4px;
  padding: 4px 14px 4px 10px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  svg {
    height: 14px;
  }
  .coupon-space {
    margin: 0 3px;
  }
  .gift-num {
    color: #13cb75;
  }
`;

export const PayType = styled.div`
  position: relative;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  line-height: 22px;
  img.wechat {
    width: 21px;
    margin-right: 10px;
  }
  img.ali {
    margin-right: 10px;
  }
  button {
    all: unset;
    margin-left: 8px;
    color: var(--main-color);
    cursor: pointer;
    &.disabled {
      color: #748080;
      cursor: not-allowed;
    }
    &:active {
      opacity: 0.9;
    }
  }
`;
